module.exports = __webpack_public_path__ + "static/img/leumi.56dcf16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/leumi.jpg
// module id = DVpZ
// module chunks = 6